import { useEffect, useRef, useState } from 'react';

export default function Modal({
  open,
  title,
  children,
  onClose,
  className = '',
  contentClassName = '',
  hideHeader = false,
}) {
  const [mounted, setMounted] = useState(Boolean(open));
  const [state, setState] = useState(open ? 'open' : 'closed');
  const closeTimerRef = useRef(null);

  useEffect(() => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }

    if (open) {
      setMounted(true);
      requestAnimationFrame(() => setState('open'));
      return;
    }

    if (mounted) {
      setState('closed');
      closeTimerRef.current = setTimeout(() => {
        setMounted(false);
        closeTimerRef.current = null;
      }, 260);
    }
  }, [open, mounted]);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!mounted) return null;

  return (
    <div
      className={`fixed inset-0 z-50 ${className}`.trim()}
      data-sg-modal-state={state}
    >
      <button
        type="button"
        aria-label="Закрыть"
        className="sg-modal-overlay absolute inset-0 bg-slate-900/25"
        onClick={() => onClose?.()}
      />

      <div className="relative z-10 flex min-h-full items-center justify-center p-2 xs:p-4">
        <div
          role="dialog"
          aria-modal="true"
          className={`sg-modal-panel w-full max-w-[calc(100vw-1rem)] xs:max-w-md rounded-xl xs:rounded-2xl border border-slate-200 bg-white shadow-2xl max-h-[calc(100vh-1rem)] xs:max-h-[calc(100vh-2rem)] overflow-auto ${contentClassName}`.trim()}
        >
          {!hideHeader && (
          <div className="flex items-center justify-between gap-2 xs:gap-3 px-3 xs:px-5 pt-3 xs:pt-5">
            <h2 className="text-base xs:text-lg font-bold text-slate-900">{title}</h2>
            <button
              type="button"
              onClick={() => onClose?.()}
              className="inline-flex h-8 w-8 xs:h-9 xs:w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 hover:bg-slate-200 text-lg xs:text-xl"
              aria-label="Закрыть"
            >
              ×
            </button>
          </div>
          )}

          <div className="px-3 xs:px-5 pb-3 xs:pb-5 pt-3 xs:pt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
